import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "is-fullwidth" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import GameModal from "./game-modal.vue";
import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import { ref, computed, onMounted } from "vue";

interface Props {
  userId: number;
  gameId: number;
  gamePurchaseExists: boolean;
  gamePurchaseId?: number;
  pencilIcon: string;
  plusIcon: string;
  removeIcon: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'add-game-to-library',
  props: {
    userId: {},
    gameId: {},
    gamePurchaseExists: { type: Boolean },
    gamePurchaseId: {},
    pencilIcon: {},
    plusIcon: {},
    removeIcon: {}
  },
  setup(__props: any) {

const props = __props;

// Reactive data
const mutableGamePurchase = ref<any>({});
const isModalActive = ref(false);
const gameModalState = computed(() => (props.gamePurchaseExists ? "update" : "createWithGame"));

// Methods
// TODO: Add a proper type here?
function activateModal(game: any = {}) {
  document.documentElement.classList.add("is-clipped");

  // TODO: Cursed, do this better.
  if (Object.keys(mutableGamePurchase.value).length === 0) {
    mutableGamePurchase.value = { game: game };
  }
  isModalActive.value = true;
}

function deactivateModal() {
  document.documentElement.classList.remove("is-clipped");
  isModalActive.value = false;
}

function closeAndRefresh() {
  deactivateModal();
}

async function addGameToLibrary() {
  const response = await fetch(`/games/${props.gameId}.json`, {
    headers: {
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    // TODO: Handle error, need to render an error toast or something.
    return;
  }

  const game = await response.json();
  activateModal(game);
}

function editGameInLibrary() {
  // TODO: why does this work...
  activateModal();
}

async function removeGameFromLibrary() {
  let removeGameFromLibraryPath = `/games/${props.gameId}/remove_game_from_library`;

  const headers: HeadersInit = {
    Accept: "application/json",
    "X-CSRF-Token": Rails.csrfToken()!
  };

  const response = await fetch(removeGameFromLibraryPath, {
    method: "DELETE",
    headers,
    credentials: "same-origin"
  });

  if (response.ok) {
    Turbolinks.visit(window.location.href);
  } else {
    // Handle error
    console.error("Failed to remove game from library");
  }
}

function onSubmit() {
  Turbolinks.visit(window.location.href);
}

// Lifecycle
onMounted(() => {
  if (props.gamePurchaseId) {
    // TODO: Make this use async/await, although I'm not 100% sure if that's allowed here.
    fetch(`/game_purchases/${props.gamePurchaseId}.json`, {
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then((response) => {
        return response.json().then((json) => {
          if (response.ok) {
            return Promise.resolve(json);
          }
          return Promise.reject(json);
        });
      })
      .then((gamePurchase) => {
        mutableGamePurchase.value = gamePurchase;
      });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.gamePurchaseExists)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (editGameInLibrary())),
          class: "button is-fullwidth is-primary mr-5 mr-0-mobile"
        }, [
          _createElementVNode("span", {
            class: "icon",
            innerHTML: __props.pencilIcon
          }, null, 8, _hoisted_2),
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "Edit game in library", -1))
        ]))
      : _createCommentVNode("", true),
    (__props.gamePurchaseExists)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (removeGameFromLibrary())),
          class: "button is-fullwidth is-danger mr-5 mr-0-mobile mt-10"
        }, [
          _createElementVNode("span", {
            class: "icon",
            innerHTML: __props.removeIcon
          }, null, 8, _hoisted_3),
          _cache[4] || (_cache[4] = _createElementVNode("span", null, "Remove from library", -1))
        ]))
      : _createCommentVNode("", true),
    (!__props.gamePurchaseExists)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (addGameToLibrary())),
          class: "button is-fullwidth is-primary mr-5 mr-0-mobile"
        }, [
          _createElementVNode("span", {
            class: "icon",
            innerHTML: __props.plusIcon
          }, null, 8, _hoisted_4),
          _cache[5] || (_cache[5] = _createElementVNode("span", null, "Add to library", -1))
        ]))
      : _createCommentVNode("", true),
    (isModalActive.value)
      ? (_openBlock(), _createBlock(GameModal, _mergeProps({
          key: 3,
          isActive: isModalActive.value,
          gameModalState: gameModalState.value,
          userId: __props.userId
        }, mutableGamePurchase.value, {
          onClose: deactivateModal,
          onCloseAndRefresh: closeAndRefresh,
          onCreate: onSubmit
        }), null, 16, ["isActive", "gameModalState", "userId"]))
      : _createCommentVNode("", true)
  ]))
}
}

})